export default __webpack_public_path__ + "static/media/canvaser.b641313f.png";